import { DownOutlined, UpOutlined } from "@ant-design/icons";

interface SortIconsProps {
  isActive: boolean;
  direction: "asc" | "desc";
}

const SortIcons: React.FC<SortIconsProps> = ({ isActive, direction }) => {
  const activeColor = "text-blue-600";
  const inactiveColor = "text-gray-400";

  return (
    <div className="flex flex-col items-center leading-none gap-[1px]">
      <UpOutlined
        className={`text-[10px] transition ${
          isActive && direction === "asc" ? activeColor : inactiveColor
        }`}
      />
      <DownOutlined
        className={`text-[10px] transition ${
          isActive && direction === "desc" ? activeColor : inactiveColor
        }`}
      />
    </div>
  );
};  

export default SortIcons;
